var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResellerHeadDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "492px",
    height: "360px",
    viewBox: "0 0 492 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.208,100.86 C356.865,100.86 359.739,103.77 359.739,107.46 L359.739,253.59 C359.739,257.28 356.865,260.19 353.208,260.19 L130.623,260.19 C126.966,260.19 124.092,257.28 124.092,253.59 L124.092,107.46 C124.092,103.77 126.966,100.86 130.623,100.86 L353.208,100.86 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-49.0%",
    y: "-51.8%",
    width: "198.0%",
    height: "245.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 33,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.0304186%",
    y1: "50%",
    x2: "104.267765%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030E2E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030E2E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.38466734%",
    y1: "48.6577181%",
    x2: "96.4404047%",
    y2: "48.6577181%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455B92",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4158C2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.12765957%",
    y1: "51.0067114%",
    x2: "99.3583249%",
    y2: "51.0067114%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.9591837%",
    y1: "-180.442177%",
    x2: "47.9591837%",
    y2: "52.2108844%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.074665%",
    y1: "-324.830393%",
    x2: "49.074665%",
    y2: "46.4043419%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.4056122%",
    y1: "-302.405063%",
    x2: "48.4056122%",
    y2: "102.151899%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.5851946%",
    y1: "-372.074883%",
    x2: "49.5851946%",
    y2: "54.7581903%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.0108488%",
    y1: "-199.288256%",
    x2: "49.0108488%",
    y2: "85.0533808%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.1595405%",
    y1: "-2.13381555%",
    x2: "50.1595405%",
    y2: "96.8173599%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.4897959%",
    y1: "14.0306122%",
    x2: "49.4897959%",
    y2: "285.79932%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.6700702%",
    y1: "22.8549734%",
    x2: "50.6700702%",
    y2: "230.599848%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0319081%",
    y1: "22.3932282%",
    x2: "50.0319081%",
    y2: "127.664486%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.2117347%",
    y1: "2.49056604%",
    x2: "51.2117347%",
    y2: "243.698113%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.5739796%",
    y1: "-76.6666667%",
    x2: "50.5739796%",
    y2: "266.989247%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.116,37.65 C232.773,37.65 235.647,40.56 235.647,44.25 L235.647,190.41 C235.647,194.1 232.773,196.98 229.116,196.98 L6.531,196.98 C2.874,196.98 0,194.1 0,190.41 L0,44.25 C0,40.56 2.874,37.65 6.531,37.65 L229.116,37.65 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-49.0%",
    y: "-51.8%",
    width: "198.0%",
    height: "245.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 33,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.18 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.050007%",
    y1: "50.5791506%",
    x2: "104.371793%",
    y2: "50.5791506%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030E2E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030E2E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.486217%",
    y1: "10.3524205%",
    x2: "78.4066339%",
    y2: "92.4678506%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#576FAC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3D86",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.418,230.43 C137.418,234.12 136.893,237.81 136.11,241.23 C135.588,243.6 134.805,245.97 134.019,248.07 C128.796,261.78 117.561,272.31 103.716,277.05 C102.672,277.32 101.364,277.83 100.32,278.1 C96.663,278.88 92.742,279.42 88.824,279.42 C61.917,279.42 40.233,257.55 40.233,230.43 C40.233,203.31 62.178,181.44 88.824,181.44 C115.734,181.44 137.418,203.31 137.418,230.43 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.8%",
    y: "-29.1%",
    width: "189.5%",
    height: "188.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 15,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.294117647   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.7291003%",
    y1: "62.1260265%",
    x2: "40.4494054%",
    y2: "43.9018549%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D1FF",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.4448602%",
    y1: "8.87319619%",
    x2: "78.4728753%",
    y2: "92.4777403%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.479,67.95 C301.479,71.64 300.957,75.33 300.174,78.75 C299.652,81.12 298.869,83.49 298.083,85.59 C292.86,99.27 281.625,109.83 267.78,114.57 C267.258,114.81 266.472,115.08 265.95,115.08 C265.428,115.08 264.906,115.35 264.384,115.62 C260.727,116.4 256.806,116.94 252.888,116.94 C225.981,116.94 204.297,95.07 204.297,67.95 C204.297,40.83 226.242,19.23 252.888,19.23 C279.798,19.23 301.479,41.07 301.479,67.95 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-44.8%",
    y: "-29.2%",
    width: "189.5%",
    height: "189.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 15,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.254901961   0 0 0 0 0.564705882  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.2542206%",
    y1: "25.1981644%",
    x2: "59.8730337%",
    y2: "72.7158949%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81778",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01F79",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.5869974%",
    y1: "89.9588961%",
    x2: "36.1125388%",
    y2: "34.4685849%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC9E3",
    offset: "1.13208%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0705076551%",
    y1: "50.8361204%",
    x2: "99.6172442%",
    y2: "50.8361204%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.321207741%",
    y1: "50.8361204%",
    x2: "100.642415%",
    y2: "50.8361204%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.287081%",
    y1: "50.6493506%",
    x2: "-0.822966507%",
    y2: "50.6493506%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.227%",
    y1: "50.6493506%",
    x2: "0.100146882%",
    y2: "50.6493506%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 39,
    transform: "translate(66.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.54,279.42 C264.249,279.42 322.38,220.8 322.38,148.53 C322.38,76.23 264.249,17.64 192.54,17.64 C120.831,17.64 62.7,76.23 62.7,148.53 C62.7,220.8 120.831,279.42 192.54,279.42 Z",
    id: "Path",
    fill: "#030E2E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#030E2E",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360,107.46 L360,116.4 L124.092,116.4 L124.092,107.46 C124.092,103.77 126.966,100.86 130.623,100.86 L353.208,100.86 C356.865,100.86 360,103.77 360,107.46 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.931,110.88 C133.083,110.88 134.019,109.92 134.019,108.75 C134.019,107.61 133.083,106.65 131.931,106.65 C130.776,106.65 129.84,107.61 129.84,108.75 C129.84,109.92 130.776,110.88 131.931,110.88 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94,110.88 C139.092,110.88 140.028,109.92 140.028,108.75 C140.028,107.61 139.092,106.65 137.94,106.65 C136.785,106.65 135.849,107.61 135.849,108.75 C135.849,109.92 136.785,110.88 137.94,110.88 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.949,110.88 C145.101,110.88 146.037,109.92 146.037,108.75 C146.037,107.61 145.101,106.65 143.949,106.65 C142.794,106.65 141.858,107.61 141.858,108.75 C141.858,109.92 142.794,110.88 143.949,110.88 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.084,29.94 C111.516,28.8 113.394,25.08 112.278,21.63 C111.162,18.18 107.478,16.29 104.049,17.4 C100.617,18.54 98.739,22.23 99.855,25.71 C100.971,29.16 104.655,31.05 108.084,29.94 Z",
    id: "Path",
    fill: "#030E2E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.172,8.94 C151.626,8.94 153.615,6.96 153.615,4.47 C153.615,2.01 151.626,0 149.172,0 C146.721,0 144.732,2.01 144.732,4.47 C144.732,6.96 146.721,8.94 149.172,8.94 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.806,291 C259.26,291 261.249,288.99 261.249,286.53 C261.249,284.04 259.26,282.06 256.806,282.06 C254.355,282.06 252.366,284.04 252.366,286.53 C252.366,288.99 254.355,291 256.806,291 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.591,83.46 C340.638,79.74 340.92,73.41 337.221,69.33 C333.522,65.25 327.243,64.95 323.196,68.7 C319.149,72.42 318.867,78.75 322.566,82.83 C326.262,86.91 332.544,87.21 336.591,83.46 Z",
    id: "Path",
    fill: "#030E2E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.323,38.97 C339.027,37.41 339.147,34.74 337.59,33.03 C336.033,31.29 333.39,31.17 331.686,32.76 C329.979,34.32 329.862,36.99 331.419,38.7 C332.976,40.41 335.619,40.53 337.323,38.97 Z",
    id: "Path",
    fill: "#030E2E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.668,230.43 L319.245,230.43 C318.462,230.43 317.679,231.21 317.679,232.02 L317.679,233.34 L132.192,233.34 L132.192,235.71 L317.679,235.71 L317.679,237 C317.679,237.81 318.462,238.59 319.245,238.59 L340.668,238.59 C341.451,238.59 342.234,237.81 342.234,237 L342.234,232.02 C342.234,230.97 341.712,230.43 340.668,230.43 Z",
    id: "Path",
    fill: "#E3EAF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.668,201.99 L319.245,201.99 C318.462,201.99 317.679,202.77 317.679,203.58 L317.679,204.87 L132.192,204.87 L132.192,207.27 L317.679,207.27 L317.679,208.56 C317.679,209.37 318.462,210.15 319.245,210.15 L340.668,210.15 C341.451,210.15 342.234,209.37 342.234,208.56 L342.234,203.58 C342.234,202.5 341.712,201.99 340.668,201.99 Z",
    id: "Path",
    fill: "#E3EAF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.668,173.55 L319.245,173.55 C318.462,173.55 317.679,174.33 317.679,175.14 L317.679,176.43 L132.192,176.43 L132.192,178.8 L317.679,178.8 L317.679,180.12 C317.679,180.93 318.462,181.71 319.245,181.71 L340.668,181.71 C341.451,181.71 342.234,180.93 342.234,180.12 L342.234,175.14 C342.234,174.06 341.712,173.55 340.668,173.55 Z",
    id: "Path",
    fill: "#E3EAF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.668,145.11 L319.245,145.11 C318.462,145.11 317.679,145.89 317.679,146.67 L317.679,147.99 L132.192,147.99 L132.192,150.36 L317.679,150.36 L317.679,151.68 C317.679,152.49 318.462,153.27 319.245,153.27 L340.668,153.27 C341.451,153.27 342.234,152.49 342.234,151.68 L342.234,146.67 C342.234,145.62 341.712,145.11 340.668,145.11 Z",
    id: "Path",
    fill: "#E3EAF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    points: "154.659 206.73 149.955 206.73 149.955 242.01 154.659 242.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    points: "168.504 214.89 163.803 214.89 163.803 237 168.504 237"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero",
    points: "184.965 225.15 180.261 225.15 180.261 248.85 184.965 248.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    points: "198.81 214.62 194.109 214.62 194.109 233.85 198.81 233.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero",
    points: "215.268 220.68 210.567 220.68 210.567 254.4 215.268 254.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero",
    points: "229.113 144.84 224.412 144.84 224.412 227.79 229.113 227.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero",
    points: "245.574 148.53 240.87 148.53 240.87 183.81 245.574 183.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-13)",
    fillRule: "nonzero",
    points: "259.419 134.04 254.718 134.04 254.718 173.55 259.419 173.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-14)",
    fillRule: "nonzero",
    points: "275.877 125.61 271.176 125.61 271.176 203.58 275.877 203.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero",
    points: "289.725 152.49 285.021 152.49 285.021 192.24 289.725 192.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-16)",
    fillRule: "nonzero",
    points: "306.183 174.87 301.479 174.87 301.479 202.77 306.183 202.77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#030E2E",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.647,44.25 L235.647,53.19 L0,53.19 L0,44.25 C0,40.56 2.874,37.65 6.531,37.65 L229.116,37.65 C232.773,37.65 235.647,40.56 235.647,44.25 Z",
    id: "Path",
    fill: "url(#linearGradient-19)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.836,47.94 C8.991,47.94 9.927,46.98 9.927,45.81 C9.927,44.67 8.991,43.71 7.836,43.71 C6.684,43.71 5.748,44.67 5.748,45.81 C5.748,46.98 6.684,47.94 7.836,47.94 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.845,47.94 C15,47.94 15.936,46.98 15.936,45.81 C15.936,44.67 15,43.71 13.845,43.71 C12.693,43.71 11.757,44.67 11.757,45.81 C11.757,46.98 12.693,47.94 13.845,47.94 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.854,47.94 C21.009,47.94 21.945,46.98 21.945,45.81 C21.945,44.67 21.009,43.71 19.854,43.71 C18.702,43.71 17.766,44.67 17.766,45.81 C17.766,46.98 18.702,47.94 19.854,47.94 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1C3377",
    fillRule: "nonzero",
    points: "216.837 73.74 123.831 73.74 123.831 113.49 216.837 113.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1C3377",
    fillRule: "nonzero",
    points: "216.837 132.99 123.831 132.99 123.831 172.77 216.837 172.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E9529E",
    fillRule: "nonzero",
    opacity: 0.2,
    points: "194.37 103.5 184.44 94.29 165.891 100.59 155.181 91.38 145.776 87.96 132.453 94.29 124.092 84.27 124.092 113.25 194.37 113.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#E9529E",
    strokeWidth: 6,
    strokeLinejoin: "round",
    points: "124.092 83.73 132.453 93.48 145.776 87.18 155.181 90.87 165.891 100.08 184.44 93.75 194.106 103.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,147.21 L184.44,153 L165.891,150.9 L155.181,158.28 L145.776,164.85 L132.453,154.32 L124.092,158.01 L124.092,173.55 L194.37,173.55 C194.37,173.55 194.37,146.94 194.37,147.21 Z",
    id: "Path",
    fill: "#7089FF",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#7089FF",
    strokeWidth: 6,
    strokeLinejoin: "round",
    points: "124.092 157.47 132.453 153.81 145.776 164.34 155.181 157.74 165.891 150.36 184.44 152.49 194.106 146.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.631,107.7 C196.65,107.7 198.288,106.05 198.288,104.01 C198.288,102 196.65,100.35 194.631,100.35 C192.609,100.35 190.971,102 190.971,104.01 C190.971,106.05 192.609,107.7 194.631,107.7 Z",
    id: "Path",
    fill: "#E9529E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.631,150.36 C196.794,150.36 198.549,148.59 198.549,146.43 C198.549,144.24 196.794,142.47 194.631,142.47 C192.465,142.47 190.713,144.24 190.713,146.43 C190.713,148.59 192.465,150.36 194.631,150.36 Z",
    id: "Path",
    fill: "#7089FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.068,138.51 L23.25,138.51 C21.162,138.51 19.593,136.95 19.593,134.82 L19.593,77.43 C19.593,75.33 21.162,73.74 23.25,73.74 L106.329,73.74 C108.417,73.74 109.986,75.33 109.986,77.43 L109.986,135.09 C109.725,136.95 108.156,138.51 106.068,138.51 Z",
    id: "Path",
    fill: "#1C3377",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero",
    points: "66.357 124.56 36.312 124.56 51.204 107.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "90.915 124.56 47.808 124.56 69.492 100.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.547,101.4 C50.721,101.4 53.295,98.79 53.295,95.61 C53.295,92.4 50.721,89.79 47.547,89.79 C44.373,89.79 41.799,92.4 41.799,95.61 C41.799,98.79 44.373,101.4 47.547,101.4 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-20)",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.11,241.23 C135.588,243.6 134.805,245.97 134.019,248.07 C128.796,261.78 117.561,272.31 103.716,277.05 C102.672,277.32 101.364,277.83 100.32,278.1 L64.266,241.5 L77.328,229.65 L92.22,239.64 L107.634,225.42 L110.247,223.05 L113.643,218.58 L136.11,241.23 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.165,219.36 C114.165,218.58 113.382,217.8 112.599,217.8 L98.49,217.8 C97.707,217.8 96.924,218.58 96.924,219.36 L96.924,222.54 C96.924,223.32 97.707,224.1 98.49,224.1 L103.455,224.1 L91.959,235.71 L80.727,224.37 C79.419,223.05 77.592,223.05 76.284,224.37 L63.222,237.54 C62.7,238.08 62.7,239.13 63.222,239.91 L65.313,242.28 C65.835,242.82 66.879,242.82 67.662,242.28 L78.375,231.48 L89.607,242.82 C90.915,244.11 92.742,244.11 94.05,242.82 L107.634,228.84 L107.634,233.85 C107.634,234.63 108.417,235.44 109.203,235.44 L112.338,235.44 C113.121,235.44 113.904,234.63 113.904,233.85 L114.165,219.36 Z",
    id: "Path",
    fill: "url(#linearGradient-23)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E3EAF2",
    fillRule: "nonzero",
    points: "61.656 145.11 59.565 145.11 59.565 181.98 61.656 181.98"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-26)",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-24)",
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.5,82.5 C293.274,96.18 284.934,109.41 271.089,114.15 C270.567,114.42 269.781,114.69 269.259,114.69 L247.053,92.31 L245.226,54.63 L256.98,49.89 L260.115,42.78 L282.843,65.7 C298.5,81 299.283,80.4 298.5,82.5 Z",
    id: "Path",
    fill: "url(#linearGradient-27)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.027,93.09 C256.458,93.09 255.153,91.77 255.153,90.18 L255.153,86.52 L251.757,86.52 L251.757,90.18 C251.757,91.77 250.449,93.09 248.883,93.09 C247.314,93.09 246.009,91.77 246.009,90.18 L246.009,86.52 L243.918,86.52 C241.83,86.52 240,84.66 240,82.56 L240,52.53 C240,50.43 241.83,48.57 243.918,48.57 L246.009,48.57 L246.009,44.91 C246.009,44.1 246.27,43.32 246.792,42.78 C247.314,42.27 248.1,42 248.883,42 C250.449,42 251.757,43.32 251.757,44.91 L251.757,48.57 L255.153,48.57 L255.153,44.91 C255.153,43.32 256.458,42 258.027,42 C259.593,42 260.901,43.32 260.901,44.91 L260.901,48.57 L261.162,48.57 C263.775,48.84 265.863,49.89 267.693,51.75 C269.259,53.31 270.306,55.68 270.306,58.05 C270.306,61.5 268.476,64.65 265.341,66.24 L264.819,66.48 L265.341,66.75 C270.306,68.61 272.394,71.49 272.394,75.96 C272.394,83.88 265.341,85.71 261.162,86.25 L260.901,86.25 L260.901,90.18 C260.901,90.99 260.64,91.77 260.115,92.31 C259.332,92.82 258.549,93.09 258.027,93.09 Z M258.027,79.65 C263.25,79.65 264.297,77.28 264.297,75.18 C264.297,72.3 261.945,70.71 257.766,70.71 L247.836,70.71 L247.836,79.65 L258.027,79.65 Z M255.936,64.11 C261.162,64.11 262.206,61.74 262.206,59.91 C262.206,56.22 258.549,55.68 256.458,55.68 L248.1,55.68 L248.1,64.38 L255.936,64.38 L255.936,64.11 Z",
    id: "Shape",
    fill: "url(#linearGradient-28)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-29)",
    fillRule: "nonzero",
    points: "90.915 150.63 61.131 150.63 61.131 159.6 90.915 159.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-30)",
    fillRule: "nonzero",
    opacity: 0.3,
    points: "60.87 150.63 23.511 150.63 23.511 159.6 60.87 159.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-31)",
    fillRule: "nonzero",
    points: "44.934 176.19 60.609 176.19 60.609 166.95 44.934 166.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-32)",
    fillRule: "nonzero",
    opacity: 0.3,
    points: "60.609 176.19 105.543 176.19 105.543 166.95 60.609 166.95"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellerHeadDark);
export default __webpack_public_path__ + "static/media/ResellerHeadDark.3dfe191ade5e0c73784393fa24f12abd.svg";
export { ForwardRef as ReactComponent };